import React from 'react';
import { useLocaleContext } from '../../../../../context/LocaleContext';
import { unixFormat } from '../../../../../helpers/times';
import { hexToRgba } from '../../../../../helpers/hexToRgb';
import ScheduleEpisodeStatus from '../../../ScheduleComponents/ScheduleEpisodeStatus';
import ScheduleHeaderActions from '../../../ScheduleComponents/ScheduleHeaderActions';
import EpisodeRecordStatus from '../../../ScheduleComponents/EpisodeRecordStatus';
import { useApplicationContext } from '../../../../../context/ApplicationContext';
import { useEventContext } from '../../../../../context/EventContext';
import { usePlayerContext } from '../../../../../context/PlayerContext';
import { useWidgetContext } from '../../../../../context/WidgetContextProvider';

import './style.scss';

const ScheduleMemberLineCard = ({ episode, member, showHall = true, settings = null, onClick }) => {
    const $locale = useLocaleContext();
    const { isWidget } = useWidgetContext();
    const { isPlayerWidget } = usePlayerContext();
    const { handleBookmark, bookmarkEpisodeIds } = useApplicationContext();
    const { event } = useEventContext();

    const memberTopic = episode.groups
        .map(({ members }) => members)
        .flat()
        .filter(({ member: episodeMember }) => episodeMember.id === member.id)
        .map((currentMember) => $locale.getProperty(currentMember, 'topic'))
        .join(', ');

    return (
        <div
            className="schedule-member-card-line background-blur"
            style={{
                borderTopColor: episode?.stream?.color ?? 'none',
            }}
        >
            {
                (showHall && !episode.hideStreamDescription) &&
                <div className="schedule-member-card-line-hall">
                    <p>
                        {$locale.getProperty(episode.stream, 'description')}
                    </p>
                </div>
            }
            <div className="schedule-member-card-line-header">
                <div className="schedule-member-card-line-header__time">
                    {unixFormat(episode.timeStart, 'HH:mm')} — {unixFormat(episode.timeStop, 'HH:mm')}
                </div>
                <div className="schedule-member-card-line-header__info">
                    <EpisodeRecordStatus
                        episode={episode}
                        displayRecord={settings?.displayEpisodeRecord ?? false}
                    >
                        {
                            (settings?.showMemberPopupStatus ?? settings?.showStatuses) &&
                            <ScheduleEpisodeStatus
                                timeStart={episode.timeStart}
                                timeStop={episode.timeStop}
                            />
                        }
                        {!isPlayerWidget &&
                            <ScheduleHeaderActions
                                episode={episode}
                                isFormatVisible={settings?.showMemberPopupFormat ?? settings?.showFormats}
                                isCalendarVisible={settings?.showMemberPopupAddToCalendar ?? settings?.showAddToCalendar}
                                handleBookmark={handleBookmark}
                                bookmarkEpisodeIds={bookmarkEpisodeIds}
                                isBookmarkVisible={!isWidget && event?.moduleEpisode?.episodeFavorite}
                            />
                        }
                    </EpisodeRecordStatus>
                </div>
            </div>
            <h2
                className="schedule-member-card-line-title"
                onClick={onClick}
            >
                {$locale.getProperty(episode, 'name')}
            </h2>
            {
                !!memberTopic &&
                <p className="schedule-member-card-line-topic">
                    <span className="schedule-member-card-line-topic-title">
                        {$locale.get('member.label.theme')}:&nbsp;
                    </span>
                    {
                        memberTopic
                    }
                </p>
            }
        </div>
    )
};

export default ScheduleMemberLineCard;
